let tTimeoutId: any = null

let pendingTranslations: [string, Record<string, string | number>, (value: unknown) => void, (reason?: any) => void][] =
  []

async function translate(messageKey: string, params: Record<string, string | number> = {}, language?: string) {
  const translation = new Promise((resolve, reject) => {
    pendingTranslations.push([messageKey, params, resolve, reject])
  })

  let l: string
  if (language) {
    l = language
  } else {
    l = 'en'
    if (window.location.pathname.match(/\/fr(?:\/|\?|$)/)) {
      l = 'fr'
    }
  }

  // wait 1 tick to collect translations
  tTimeoutId =
    tTimeoutId ||
    setTimeout(async () => {
      tTimeoutId = null
      const beingTranslated = pendingTranslations
      pendingTranslations = []
      const translations = await fetch('/_uplandjs/t', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': l
        },
        body: JSON.stringify({
          translations: beingTranslated.map(([messageKey, params]) => [messageKey, params])
        })
      }).then((res) => res.json())

      beingTranslated.forEach(([, , resolve], i) => resolve(translations[i]))
    }, 0)

  return translation
}

export function tMagic() {
  return translate
}
